"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const is_object_1 = tslib_1.__importDefault(require("./is-object"));
const recursive_error_1 = tslib_1.__importDefault(require("./recursive-error"));
/**
 * @category High Order Guard
 * @return a `Guard` that checks if the values of the object passed respect the types of the guards passed
 * @throws {RecursiveError} When calling the `self` guard in the callback
 * @example
 * ```typescript
 *     const isGrades = RecordOf([isNumber]);
 * ```
 * @example
 * ```typescript
 *   type Grades = { [name: string]: number | Grades };
 *   const isGrades = RecordOf<Grades>((self) => [isNumber, self]);
 * ```
 */
const RecordOf = (guards) => {
    const isRecordOf = (rec) => {
        return ((0, is_object_1.default)(rec) &&
            Object.values(rec).every((v) => generatedGuards.some((guard) => guard(v))));
    };
    const generatedGuards = recursive_error_1.default.assert((forbidCall) => typeof guards === "function" ? guards(forbidCall(isRecordOf)) : guards);
    return isRecordOf;
};
exports.default = RecordOf;
